export default "__VITE_ASSET__ffef8a33__"